module.exports = __webpack_public_path__ + "assets/img/es-185ba4bd.png";